import { render, staticRenderFns } from "./modalABM.vue?vue&type=template&id=33874cf1&"
import script from "./modalABM.vue?vue&type=script&lang=js&"
export * from "./modalABM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports